import { render } from "./IconSearch.vue?vue&type=template&id=30584fd9"
const script = {}
script.render = render

export default script